export const isInIframe = (): boolean => {
  return window.location !== window.parent.location
}
